export type UpdateDepartmentErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class UpdateDepartmentError extends Error {
    code: UpdateDepartmentErrorCode;

    constructor(code: UpdateDepartmentErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
